import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import 'draft-js/dist/Draft.css';

import {
  Box,
  Stack,
  Typography,
  TextField,
  Checkbox,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  Popover,
  Tooltip,
  CircularProgress
} from '@mui/material';

// import FbFieldsCustomEvent from './FbFieldsCustomEvent';
import {
  nameFields,
  languageMeta,
  languageFieldMap,
  getDisplaySelectedFieldName,
  getSelectedOptionFieldsName
} from '../../../i18n';

import useGlobalStatus from '../../../hook/useGlobalStatus';
import useFieldsData from '../../../hook/useFieldsData';
import useUtils from '../../../hook/useUtils';

import { generateUniqueKey } from '../../../utils/date';
import { handleColorSystem } from '../../customComponent/colorSystem';
import { BoxBorderGrey, CustomFormLabel } from '../../customComponent';
import { SearchInputBlueMain } from '../../customComponent/form';

import {
  SearchIcon,
  PagesOutlinedIcon,
  HelpOutlineIcon,
  EditOutlinedIcon,
  HighlightOffIcon,
  DeleteOutlineOutlinedIcon
} from '../../../constants/images';

import theme from '../../../theme';

import SortFields from '../SortFields';
import { el } from 'date-fns/locale';


const mediaMainColor = theme.palette.facebook.main
const fieldsBlockHeight = '400px';

//自定義指標
const getCustomFields = (currentFields) => {
  const customFields = _.filter(currentFields, f => f.type === 'CUSTOM' && f.cid === null);
  return [{
    category: 'custom',
    name: 'custom',
    child: customFields
  }]
}

const checkFieldIsSelected = (currentData, originalData) => {
  return _.findIndex(currentData, ['expression', originalData]) > -1 ? true : false;
}

const getOriginalFieldName = (allOptionFields, requiredFields, name) => {
  const target = _.flatMap(allOptionFields, item => {
    return _(_.concat(item.child, requiredFields)).filter({ expression: name }).value()
  })[0];

  if (target.type !== 'CUSTOM') {
    return <FormattedMessage id={`facebook.field.${target.expression}`} />
  }
  return target.name;
}

const FbFieldsData = (props) => {
  const {
    selectedAdAccounts,
    requiredFields,
    allOptionFields,
    setAllOptionFields,
    selectedOptionFields,
    setSelectedOptionFields,
    handleModalDetail,
    inputErrorMsg,
    downloadInputErrorMsg,
    updateSortFields,
    setUpdateSortFields,
    excelSheetSelected,
    reportLanguage,
    // origiCustomData,
    // setOrigiCustomData,
    // selectedCustomFields,
    // setSelectedCustomFields,
    // setModalName,
    // setIsLoading,
    // scrollToAnchor
  } = props;

  const intl = useIntl();
  const { currentActiveData, entryPath, setEntryPath } = useGlobalStatus();
  const [optionalFields, requiredMetricsFields, updateRequiredFields] = useFieldsData();
  const [customEventProcess, setCustomEventProcess] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterOptionFields, setFilterOptionFields] = useState([]);
  const [transformExpressToTw] = useUtils();
  const [showButton, setShowButton] = useState(false);
  const [currenOptionFields, setCurrenOptionFields] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const popOpen = Boolean(anchorEl);
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem('FACEBOOK');

  const currentDataWithCustomFields = getCustomFields(currentActiveData.fields);

  // const checkHaveCustomEvent = (currentData, customData) => {
  //   let haveCustomEvent;
  //   const customEvent = currentData.fields.filter(el => el.cid !== null);

  //   if (entryPath.includes('edit') && customEvent.length && customData.length) {
  //     haveCustomEvent = true;
  //   } else {
  //     haveCustomEvent = false;
  //   }

  //   return haveCustomEvent;
  // }

  useEffect(() => {
    if (entryPath.includes('edit')) {
      const nameKey = languageFieldMap[reportLanguage];

      const sortedFields = currentActiveData.fields
        // 將 'reach' 欄位的 indexNumber 設為 300，排在最後
        .map((item) => ({
          ...item,
          indexNumber: item.expression === 'reach' ? 300 : item.indexNumber,
        }))
        // 根據 indexNumber 進行排序，並將 null 值排在最後
        .sort((a, b) => {
          if (a.indexNumber === null) return 1;
          if (b.indexNumber === null) return -1;
          return a.indexNumber - b.indexNumber;
        })
        // 過濾掉 format 為 'STRING' 的欄位
        .filter((item) => item.format !== 'STRING')
        // 為每個欄位設定本地化的名稱
        .map((item) => ({
          ...item,
          [nameKey]: item.name
        }));

      setSelectedOptionFields(sortedFields);
    }
  }, [entryPath, currentActiveData]);

  useEffect(() => {
    const nameKey = languageFieldMap[reportLanguage];

    setSelectedOptionFields((prevFields) =>
      prevFields.map((field) => {
        const hasNameKey = Object.hasOwn(field, nameKey);

        return {
          ...field,
          [nameKey]: hasNameKey ? field[nameKey] : getSelectedOptionFieldsName('facebook', field, reportLanguage),
        };
      })
    );
  }, [reportLanguage])

  //更新顯示欄位
  useEffect(() => {
    let allDisplayOptionFields = [];
    const languageField = languageMeta.find(lang => lang.label === reportLanguage).field;

    const updateOptionalFieldsName = optionalFields.map((group) => {
      const updateChild = group.child.map((item) => {
        const i18nKey = `facebook.field.${item.expression}`;
        return {
          ...item,
          [languageField]: intl.formatMessage({ id: i18nKey }),
        }
      })

      return {
        ...group,
        child: updateChild,
      }
    })

    if (entryPath.includes('create')) {
      allDisplayOptionFields = updateOptionalFieldsName;

    } else {
      allDisplayOptionFields = currentDataWithCustomFields.concat(updateOptionalFieldsName);
      // allDisplayOptionFields = customDisplayFields.concat(currentDataWithCustomFields, optionalFields);
    }
    setAllOptionFields(allDisplayOptionFields);

  }, [optionalFields.length, selectedAdAccounts])

  useEffect(() => {
    let fields;

    if (searchKeyword) {
      fields = allOptionFields.map((el) => {
        const filterChild = el.child.filter(elem => {
          const lowerKeyword = searchKeyword.toLowerCase();
          return nameFields.some(
            key => elem[key] && elem[key].toLowerCase().includes(lowerKeyword)
          );
        })
        return { ...el, child: filterChild };
      });
    } else {
      fields = allOptionFields;
    }

    setFilterOptionFields(fields);
  }, [searchKeyword, allOptionFields]);

  //自訂事件(顯示分類)
  // const customDisplayFields = Array.from(new Set(origiCustomData
  //   .map((s) => s.cidname)))
  //   .map((lab, index) => {
  //     return {
  //       category: lab,
  //       name: "自訂事件",
  //       child: origiCustomData.filter((item) => item.cidname === lab)
  //         .map((edition) => {
  //           return {
  //             name: edition.name,
  //             expression: edition.id,
  //             format: 'DEFAULT',
  //             type: 'CUSTOM',
  //             cidname: edition.cidname,
  //             cid: edition.cid,
  //           }
  //         })
  //     }
  //   })

  const handleTitle = (field) => {
    const allFields = _.flatMap(requiredMetricsFields.concat(optionalFields), f => f.child);
    return transformExpressToTw(field.expression, allFields, 'facebook', reportLanguage);
  }

  const handleFieldFormat = (field) => {
    const format = field.format === 'PERCENT' ? 'percentage'
      : field.format === 'DEFAULT' ? 'number'
        : 'amount'

    return format;
  }

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchKeyword(value);
  };

  const changeOptionFields = (e, field) => {
    const { checked } = e.target;
    const nameKey = languageFieldMap[reportLanguage];

    if (checked) {
      setSelectedOptionFields(prev => {
        const hasNameKey = Object.hasOwn(field, nameKey);

        return [
          ...prev,
          {
            ...field,
            [nameKey]: hasNameKey ? field[nameKey] : getSelectedOptionFieldsName('facebook', field, reportLanguage),
            indexNumber: field.indexNumber ?? prev.length + 1,
          }
        ];
      })
    } else {
      setSelectedOptionFields(prev => {
        return prev.filter(el => {
          return el.expression !== field.expression;
        })
      })
    }
  }

  // const handleDeleteOptionFields = (e, fieldsName) => {
  //   const deletFields = selectedOptionFields.filter((el) => {
  //     return el.name !== fieldsName;
  //   });
  //   setSelectedOptionFields(deletFields);
  // }

  const handleDeleteFields = (e, field, type) => {
    setCurrenOptionFields(null);

    const cancelFields = selectedOptionFields.filter(el => el.name !== field.name)
    setSelectedOptionFields([...cancelFields]);

    if (type === 'deletefield') {
      const updateFields = allOptionFields.map(el => ({
        ...el,
        child: el.category === 'custom' ? el.child.filter(child => child.expression !== field.expression) : el.child
      }));
      setAllOptionFields(updateFields);
    }
  }

  const changeCurrentOptionFields = (value) => {
    const nameKey = languageFieldMap[reportLanguage];

    setCurrenOptionFields(prev => ({
      ...prev,
      name: value,
      ...(nameKey ? { [nameKey]: value } : {}),
    }));
  }

  const closeOptionFieldsName = () => {
    setAnchorEl(null);

    if (!currenOptionFields?.name) return;

    setSelectedOptionFields(prev =>
      prev.map(el => {
        if (el.expression === currenOptionFields.expression) {
          const updatedField = { ...el };

          // 根據報表語言取得對應的名稱欄位鍵值
          const languageField = languageFieldMap[reportLanguage];
          if (languageField) {
            updatedField[languageField] = currenOptionFields[languageField];
            updatedField.name = currenOptionFields.name;
          }

          return updatedField;
        }
        return el;
      })
    );

    setCurrenOptionFields(null);
  };

  const handleshowButton = (field, method) => {
    if (field.type === 'CUSTOM' && !field.cid) {
      method === 'enter' ? setShowButton(true) : setShowButton(false);
    }
  }

  //排序欄位
  const handleUpdateSortFields = (sortFields) => {
    if (!sortFields || sortFields.length === 0) return;
    setSelectedOptionFields(sortFields);
  }

  // console.log('optionalFields', optionalFields);

  return (
    <Box mb={5}>
      <Typography
        sx={{
          ...theme.typography.h4_normal,
          mb: 2,
          color: theme.palette.grey.w700,
        }}
      >
        <PagesOutlinedIcon sx={{ mr: 0.5, verticalAlign: 'sub' }} />
        <FormattedMessage id="createData.header.facebookField" />
      </Typography>

      <Box mb={2}>
        <Stack variant='between-center'>
          <CustomFormLabel>
            <FormattedMessage id="createData.field.facebookTitle" /><span>*</span>
          </CustomFormLabel>

          {/* <FbFieldsCustomEvent
            allOptionFields={allOptionFields}
            setAllOptionFields={setAllOptionFields}
            customDisplayFields={customDisplayFields}
            origiCustomData={origiCustomData}
            setOrigiCustomData={setOrigiCustomData}
            selectedCustomFields={selectedCustomFields}
            setSelectedCustomFields={setSelectedCustomFields}
            setCurrenOptionFields={setCurrenOptionFields}
            selectedAdAccounts={selectedAdAccounts}
            setModalName={setModalName}
            scrollToAnchor={scrollToAnchor}
            setIsLoading={setIsLoading}
            setSelectedOptionFields={setSelectedOptionFields}
            setCustomEventProcess={setCustomEventProcess}
          /> */}
        </Stack>

        <BoxBorderGrey sx={{ display: 'flex', padding: 0 }} >
          {/* 重要指標 */}
          <Box
            sx={{
              flex: 1,
              borderRight: `1px solid ${theme.palette.grey.w300}`
            }}
          >
            <Box sx={{ padding: '16px 16px 0' }} >
              <Typography
                sx={{
                  paddingBottom: '4px',
                  borderBottom: `1px solid ${theme.palette.grey.w300}`
                }}
              >
                <FormattedMessage id="createData.field.importantFields" />
              </Typography>
            </Box>

            <Box pt={1} pl={2}>
              {requiredFields.map((el) => {
                return (
                  <FormControlLabel
                    key={el.expression}
                    control={
                      <Checkbox
                        size="small"
                        name={el.expression}
                        color={colorSystem}
                        checked={checkFieldIsSelected(selectedOptionFields, el.expression)}
                        onChange={(e) => changeOptionFields(e, el)}
                      />
                    }
                    label={<FormattedMessage id={`facebook.field.${el.expression}`} />}
                    sx={{ display: 'block' }}
                  />
                )
              })
              }
            </Box>

          </Box>

          {/* 自選欄位 */}
          <Box
            sx={{
              flex: 2,
              borderRight: `1px solid ${theme.palette.grey.w300}`
            }}
          >
            <Box sx={{ padding: '16px 16px 4px 16px' }} >
              <Typography
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                  paddingBottom: '4px',
                  borderBottom: `1px solid ${theme.palette.grey.w300}`
                }}
              >
                <FormattedMessage id="createData.field.userSelectedFields" />
                <Typography
                  variant="caption"
                  sx={{
                    cursor: 'pointer',
                    color: mediaMainColor
                  }}
                  onClick={() => handleModalDetail('create_custom_metric')}
                >
                  <FormattedMessage id="createData.button.createCustomMetrics" />
                </Typography>
              </Typography>

              <SearchInputBlueMain
                id="search"
                placeholder={intl.formatMessage({ id: "createData.field.searchFields" })}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                sx={{ width: "100%", marginTop: "10px" }}
                value={searchKeyword}
                onChange={handleSearchInput}
              />
            </Box>

            <Box
              pt={1}
              sx={{
                height: fieldsBlockHeight,
                overflow: 'auto',
                paddingLeft: '16px',
                paddingRight: '8px',
              }}
            >
              <>
                {customEventProcess &&
                  <Stack variant='center-center' height='100%'>
                    <CircularProgress color="inherit" size={30} />
                  </Stack>
                }
                {filterOptionFields.length > 20 &&
                  filterOptionFields.map((el) => {
                    const mainTitle = el.name === '自訂事件' ? el.category : null;
                    return (
                      <Box key={el.category}>
                        {
                          el.child?.length > 0 &&
                          <>
                            {/* 指標類別 */}
                            <Typography
                              sx={{
                                marginBottom: '8px',
                                padding: '4px 0 4px 8px',
                                backgroundColor: theme.palette.grey.w100,
                                borderRadius: '2px'
                              }}
                              title={mainTitle}
                            >
                              {
                                <FormattedMessage id={`facebook.field.category.${el.name}`} />
                              }
                            </Typography>

                            {/* 指標 */}
                            <Box pl={0.5} pb={1}>
                              {
                                el.child.map((item, index) => {
                                  const title = el.category === 'custom' ? handleTitle(item) : null;
                                  const format = el.category === 'custom' ? handleFieldFormat(item) : null;
                                  return (
                                    <Stack
                                      key={`${item.expression}_${index}`}
                                      variant='between-center'
                                      onMouseEnter={() => handleshowButton(item, 'enter')}
                                      onMouseLeave={() => handleshowButton(item, 'leave')}
                                    >
                                      <>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              size="small"
                                              name={item.expression}
                                              color={colorSystem}
                                              sx={{
                                                paddingTop: 0,
                                                paddingBottom: '2px',
                                              }}
                                              checked={checkFieldIsSelected(selectedOptionFields, item.expression)}
                                              onChange={(e) => changeOptionFields(e, item)}
                                            />
                                          }
                                          label={
                                            item.type === 'CUSTOM' ? item.name :
                                              <FormattedMessage id={`facebook.field.${item.expression}`} />
                                          }
                                          {...(item.type === 'CUSTOM' && {
                                            title: `${title} (${intl.formatMessage({
                                              id: `createFields.label.format.${format}`,
                                            })})`,
                                          })}
                                          sx={{
                                            display: 'block',
                                            marginBottom: '8px'
                                          }}
                                        />
                                        {
                                          showButton && item.type === 'CUSTOM' && !item.cid &&
                                          <Tooltip title={<FormattedMessage id="createData.button.deleteField" />}>
                                            <DeleteOutlineOutlinedIcon
                                              variant="dark"
                                              sx={{
                                                marginRight: '8px',
                                                marginBottom: '8px',
                                                '&:hover': {
                                                  color: mediaMainColor,
                                                  cursor: 'pointer'
                                                }
                                              }}
                                              onClick={(e) => handleDeleteFields(e, item, 'deletefield')}
                                            />
                                          </Tooltip>
                                        }
                                      </>
                                    </Stack>
                                  )
                                })
                              }
                            </Box>
                          </>
                        }
                      </Box>
                    )
                  })
                }
              </>
            </Box>

          </Box>

          {/* 已選欄位 */}
          <Box sx={{ flex: 1.5 }} >
            <Box sx={{ padding: '16px 16px 4px' }} >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                  paddingBottom: '4px',
                  borderBottom: `1px solid ${theme.palette.grey.w200}`
                }}
              >
                <Typography>
                  <FormattedMessage id="createData.field.selectedField" />
                  <Tooltip
                    title={
                      <Box sx={{ lineHeight: 1.5, padding: '4px' }}>
                        <Typography variant='body_xs'><FormattedMessage id="createData.field.selectedFieldTip1" /></Typography><br />
                        <Typography variant='body_xs'><FormattedMessage id="createData.field.selectedFieldTip2" /></Typography><br />
                        <Typography variant='body_xs'><FormattedMessage id="createData.field.selectedFieldTip3" /></Typography>
                      </Box>
                    }
                    placement="bottom-start"
                  >
                    <HelpOutlineIcon
                      variant="dark"
                      sx={{
                        top: '2px',
                        width: '16px',
                        height: '16px',
                        marginLeft: '4px',
                      }}
                    />
                  </Tooltip>
                </Typography>

                <SortFields
                  media="FACEBOOK"
                  allfields={selectedOptionFields}
                  excelSheetSelected={excelSheetSelected}
                  updateSortFields={updateSortFields}
                  setUpdateSortFields={setUpdateSortFields}
                  handleUpdateSortFields={handleUpdateSortFields}
                  reportLanguage={reportLanguage}
                />

              </Box>
            </Box>

            <Box
              sx={{
                height: fieldsBlockHeight,
                overflow: 'auto',
                padding: '8px 16px 0',
                transition: 'all .5s'
              }}
            >
              {/* 已選欄位 */}
              {selectedOptionFields.length > 0 &&
                selectedOptionFields.map(el => {
                  return (
                    <Box
                      key={el.expression}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '8px',
                        padding: '4px 8px 4px 4px',
                        border: `1px solid ${theme.palette.grey.w300}`,
                        borderRadius: '4px'
                      }}
                    >
                      <HighlightOffIcon
                        variant="dark"
                        sx={{
                          marginRight: '4px',
                          '&:hover': {
                            color: mediaMainColor,
                            cursor: 'pointer'
                          }
                        }}
                        onClick={(e) => handleDeleteFields(e, el, 'cancelField')}
                      />

                      <Typography
                        sx={{
                          flex: 1,
                          marginRight: '8px',
                          borderRight: `1px solid ${theme.palette.grey.w300}`,
                        }}
                      >
                        {getDisplaySelectedFieldName(el, reportLanguage)}
                      </Typography>

                      <EditOutlinedIcon
                        variant="dark"
                        sx={{
                          '&:hover': {
                            color: mediaMainColor,
                            cursor: 'pointer'
                          }
                        }}
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setCurrenOptionFields(el);
                        }}
                      />
                    </Box>
                  )
                })
              }

              {/* 修改欄位名 */}
              {currenOptionFields &&
                <Popover
                  open={popOpen}
                  anchorEl={anchorEl}
                  onClose={closeOptionFieldsName}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <Box
                    sx={{
                      width: '240px',
                      padding: '16px'
                    }}
                  >
                    <Typography variant="caption">
                      <FormattedMessage id="createData.field.enterFieldName" />
                    </Typography>
                    <TextField
                      variant="standard"
                      id="customOptionalFieldName"
                      name="customOptionalFieldName"
                      value={getDisplaySelectedFieldName(currenOptionFields, reportLanguage)}
                      onChange={(e) => changeCurrentOptionFields(e.target.value)}
                      fullWidth
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        color: theme.palette.grey.w600
                      }}
                    >
                      <FormattedMessage id="createData.field.sourceField" />{getOriginalFieldName(allOptionFields, requiredFields, currenOptionFields.expression)}
                    </Typography>
                  </Box>

                </Popover>
              }

            </Box>
          </Box>

        </BoxBorderGrey>
        {
          <FormHelperText error>
            {inputErrorMsg.optionFieldName}
            {inputErrorMsg.selectFields}
            {downloadInputErrorMsg.optionFieldName}
            {downloadInputErrorMsg.selectFields}
          </FormHelperText>
        }
      </Box>
    </Box>
  )
}

export default FbFieldsData;